import EtchCarousel from './EtchCarousel.component';

export default EtchCarousel;
